import React from 'react';

export const NewTabIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9615 0.30908C15.9109 0.18664 15.8134 0.08911 15.6909 0.03845C15.6298 0.01318 15.5651 0 15.5 0H8.5C8.22363 0 8 0.22363 8 0.5C8 0.77637 8.22363 1 8.5 1H14.293L7.14649 8.14648C6.95118 8.34179 6.95118 8.6582 7.14649 8.85351C7.24415 8.95117 7.37208 8.99999 7.50001 8.99999C7.62794 8.99999 7.75587 8.95116 7.85353 8.85351L15 1.70703V7.5C15 7.77637 15.2236 8 15.5 8C15.7764 8 16 7.77637 16 7.5V0.5C16 0.43494 15.9868 0.37018 15.9615 0.30908Z"
        fill="#currentColor"
      />
      <path
        d="M15.5 11C15.2236 11 15 11.2236 15 11.5V14C15 14.5518 14.5518 15 14 15H2C1.44873 15 1 14.5518 1 14V2C1 1.44873 1.44873 1 2 1H4.5C4.77637 1 5 0.77637 5 0.5C5 0.22363 4.77637 0 4.5 0H2C0.89697 0 0 0.89698 0 2V14C0 15.1025 0.89697 16 2 16H14C15.1025 16 16 15.1025 16 14V11.5C16 11.2236 15.7764 11 15.5 11Z"
        fill="#currentColor"
      />
    </svg>
  );
};
